import React from 'react'

import { PageTemplate, Header } from 'components'

const NotFoundPage = () => {
  return (
    <PageTemplate header={<Header />}>
      <p>404 Not Found</p>
    </PageTemplate>
  )
}

export default NotFoundPage


// WEBPACK FOOTER //
// ./src/components/pages/NotFoundPage/index.js